// Dependencies
import React from 'react'
import _ from 'lodash'
import { AppContext } from '../contexts/AppContext'
import styled, { css } from 'styled-components'

// Types
import { Types, Containers } from '../types'

// Hooks
import { useDebug } from '../hooks'
import ProductAttributeSelect from '../components/ProductAttributeSelect'
import { Helpers } from '../utils'
 
export const ProductVariableSelectWrapper = styled.div(
  ({ theme: { general, components } }) => css`
    display: flex;
    flex-direction: column;
    row-gap: 1em;
    background-color: ${components.addToCart.background};
    //margin-bottom: 1.5em;
    // NOTE: Dirty but usable for now
    ${({ theme: { general } }) => Helpers.clamp('padding', general.wrapper.padding.inline / 1.25, general.wrapper.padding.inline)}
    ${({ theme: { general } }) => Helpers.clamp('padding-top', general.wrapper.padding.block / 1.25, general.wrapper.padding.block)}
    ${({ theme: { general } }) => Helpers.clamp('padding-bottom', general.wrapper.padding.inline / 1.25, general.wrapper.padding.inline)}
`);

const ProductVariableSelect = ({ options: {selected, available}, handleAttributesSelect: handleSelect, attributes, ...product }: any) => {

  useDebug(`ProductVariableSelect [${product.name}/${JSON.stringify(selected, available)}}]`)
  
  const getAtrributeProps = React.useCallback(({attrIndex, name, attribute}: any) => {    
    const newAttribute = {...attribute};

    newAttribute.options = Object.entries(newAttribute.options)
      .map(([value, label], optIndex) => ({
        label, 
        value, 
        selected: selected[attrIndex] === value, 
        available: name in available ? available[name].includes(value) : false
      })) 

    return newAttribute;
  }, [selected, available]);

  return (
    <ProductVariableSelectWrapper>
      {
        Object.entries(attributes).filter(([name, attribute]: any) => name in available).map(([name, attribute]: any, index: any) => (
          <ProductAttributeSelect
            key={`${name}-${index}`}
            {...getAtrributeProps({attrIndex: index, name, attribute})}
            name={name}
            onSelect={(value: string) => handleSelect({name, value})} // qty ?
          />
        ))
      }
    </ProductVariableSelectWrapper> 
  )
}

const productSelectMap: any = {
  'variable': ProductVariableSelect
}

export const ProductSelect = (product: any) => {
  useDebug('SelectArea')

  const ProductSelectView: any = React.useMemo(
    () => {
      if (!(product.type in productSelectMap)) {
        return null;
      }
      return productSelectMap[product.type];
    }, [product.type]
  )

  //if (!ProductSelectView) throw Error(`Product select type ${product.type} is not supported.`);
  if (!ProductSelectView) return null;
  return <ProductSelectView {...product} />

}

export default ProductSelect;